import * as z from 'zod';

export const QueryGuestsRequest = z.object({
  query: z
    .object({
      filter: z
        .object({
          _id: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          eventId: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          rsvpId: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          contactId: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          memberId: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          secondaryLanguageCode: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          ticketNumber: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          orderNumber: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          attendanceStatus: z
            .object({
              $eq: z.string(),
              $in: z.array(z.string()),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          guestType: z
            .object({
              $eq: z.string(),
              $in: z.array(z.string()),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          'guestDetails.checkedIn': z
            .object({
              $eq: z.boolean(),
              $exists: z.boolean(),
              $ne: z.boolean(),
            })
            .partial()
            .strict()
            .optional(),
          tickets: z
            .object({ $exists: z.boolean() })
            .partial()
            .strict()
            .optional(),
          _createdDate: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          _updatedDate: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          attendanceStatusUpdatedDate: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          $and: z.array(z.any()).optional(),
          $or: z.array(z.any()).optional(),
          $not: z.any().optional(),
        })
        .strict()
        .optional(),
      sort: z
        .array(
          z.object({
            fieldName: z
              .enum([
                '_createdDate',
                '_updatedDate',
                'attendanceStatusUpdatedDate',
              ])
              .optional(),
            order: z.enum(['ASC', 'DESC']).optional(),
          })
        )
        .optional(),
    })
    .catchall(z.any())
    .describe(
      'Query options. See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) for more details.'
    ),
  options: z
    .object({
      fields: z
        .array(z.enum(['GUEST_DETAILS', 'GUEST_TOTAL']))
        .max(3)
        .optional(),
    })
    .optional(),
});
export const QueryGuestsResponse = z.object({
  guests: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('Guest ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        eventId: z
          .string()
          .describe('Event ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        rsvpId: z
          .string()
          .describe(
            'RSVP ID. <br/> <br/> **Note:** Only applicable when `guestType` is `"RSVP"`.'
          )
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        orderNumber: z
          .string()
          .describe(
            'Order number. <br/> <br/> **Note:** Only applicable when `guestType` is `"BUYER"` or `"TICKET_HOLDER"`.'
          )
          .max(36)
          .optional()
          .nullable(),
        ticketNumber: z
          .string()
          .describe(
            'Ticket number. <br/> <br/> **Note:** Only applicable when `guestType` is `"TICKET_HOLDER"`.'
          )
          .max(36)
          .optional()
          .nullable(),
        tickets: z
          .array(
            z.object({
              number: z.string().describe('Ticket number.').max(36).optional(),
              definitionId: z
                .string()
                .describe('Ticket definition ID.')
                .regex(
                  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                  'Must be a valid GUID'
                )
                .optional()
                .nullable(),
              name: z
                .string()
                .describe('Ticket name.')
                .min(1)
                .max(30)
                .optional()
                .nullable(),
            })
          )
          .max(50)
          .optional(),
        contactId: z
          .string()
          .describe(
            "Guest's contact ID. See the Contacts API for more details."
          )
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        guestDetails: z
          .object({
            email: z.string().describe('Email.').email().optional().nullable(),
            firstName: z
              .string()
              .describe('First name.')
              .max(255)
              .optional()
              .nullable(),
            lastName: z
              .string()
              .describe('Last name.')
              .max(255)
              .optional()
              .nullable(),
            formResponse: z
              .object({
                inputValues: z
                  .array(
                    z.object({
                      inputName: z
                        .string()
                        .describe('Form field input name.')
                        .max(100)
                        .optional(),
                      value: z
                        .string()
                        .describe('Form field value.')
                        .max(5000)
                        .optional(),
                      values: z.array(z.string()).max(100).optional(),
                    })
                  )
                  .max(200)
                  .optional(),
              })
              .describe('Form response.')
              .optional(),
            checkedIn: z
              .boolean()
              .describe('Whether the guest has checked into the event.')
              .optional(),
            onlineConferencingLogin: z
              .object({
                link: z
                  .string()
                  .describe('Link URL to the online conference.')
                  .url()
                  .optional(),
                password: z
                  .string()
                  .describe('Password for the online conference.')
                  .optional()
                  .nullable(),
              })
              .describe(
                'The login details for the guest to access the online conference event.'
              )
              .optional(),
            phone: z
              .string()
              .describe(
                'Phone extracted from form response. If multiples phone inputs are present, first one is returned.'
              )
              .max(200)
              .optional()
              .nullable(),
            address: z
              .string()
              .describe(
                'Address extracted from form response. If multiples address inputs are present, first one is returned.'
              )
              .max(200)
              .optional()
              .nullable(),
          })
          .describe(
            'Guest details. <br/> <br/> Returned only when the `guestDetails` fieldset is sent in the request.'
          )
          .optional(),
        attendanceStatus: z
          .enum(['NOT_ATTENDING', 'ATTENDING', 'IN_WAITLIST'])
          .describe(
            'Attendance status. The attendance status updates based on status values in an RSVP object (for RSVP events) or in an Order object (for ticketed events).\nFor more information, see [Guest Attendance Status Mapping](https://dev.wix.com/docs/api-reference/business-solutions/events/registration/event-guests/guest-attendance-status-mapping). <br/> <br/> **Note:** For `guestType` of `"BUYER"` or `"TICKET_HOLDER"` the `"IN_WAITLIST"` value is not applicable.'
          )
          .optional(),
        secondaryLanguageCode: z
          .string()
          .describe(
            'Secondary language code in [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format. Used when the event ticket should be translated into another language.'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe(
            'Date and time the guest was created in `yyyy-mm-ddThh:mm:sssZ` format.'
          )
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe(
            'Date and time the guest was updated in `yyyy-mm-ddThh:mm:sssZ` format.'
          )
          .optional()
          .nullable(),
        attendanceStatusUpdatedDate: z
          .date()
          .describe("Date and time of guest's latest attendance status update.")
          .optional()
          .nullable(),
        memberId: z
          .string()
          .describe('Site member ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        guestType: z
          .enum(['RSVP', 'BUYER', 'TICKET_HOLDER'])
          .describe('Guest type.')
          .optional(),
        locale: z
          .string()
          .describe(
            'Locale in [IETF BCP 47](https://en.wikipedia.org/wiki/IETF_language_tag) format. Used when the event date and time on a ticket should be formatted into another locale.'
          )
          .optional()
          .nullable(),
        totalGuests: z
          .number()
          .int()
          .describe(
            'Number of total guests in an event (registered guests + additional ones).'
          )
          .optional()
          .nullable(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time the guest is updated.'
          )
          .optional()
          .nullable(),
        additionalDetails: z
          .object({
            _createdDate: z
              .date()
              .describe(
                'Date and time the source entity (RSVP or Order) was created.'
              )
              .optional()
              .nullable(),
            _updatedDate: z
              .date()
              .describe(
                'Date and time the source entity (RSVP or Order) was updated.'
              )
              .optional()
              .nullable(),
            rsvpStatus: z
              .enum(['YES', 'NO', 'WAITLIST'])
              .describe('Rsvp Status')
              .optional(),
            orderStatus: z
              .enum([
                'UNKNOW_ORDER_STATUS',
                'FREE',
                'PENDING',
                'PAID',
                'OFFLINE_PENDING',
                'INITIATED',
                'CANCELED',
                'DECLINED',
                'AUTHORIZED',
                'VOIDED',
                'PARTIALLY_PAID',
              ])
              .describe('Order Status')
              .optional(),
          })
          .describe('Additional Details')
          .optional(),
      })
    )
    .optional(),
  pagingMetadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items returned in the response.')
        .optional()
        .nullable(),
      offset: z
        .number()
        .int()
        .describe('Offset that was requested.')
        .optional()
        .nullable(),
      total: z
        .number()
        .int()
        .describe(
          'Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set.'
        )
        .optional()
        .nullable(),
      tooManyToCount: z
        .boolean()
        .describe(
          'Flag that indicates the server failed to calculate the `total` field.'
        )
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used.'
        )
        .optional(),
    })
    .describe('Metadata for the paginated results.')
    .optional(),
});
